import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import * as DetectionActions from '../../actions/Detection.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link as link } from 'react-router';
import Helpers from '../../helpers';

const Link = radium(link);

const styles = {
  wrap: {
    maxWidth: 720,
    margin: '20px auto',
    height: 'calc(100vh - 150px)',
  },
  wrap_TV: {
    width: '90%',
    margin: '20px auto',
  },
  container: {
    backgroundColor: '#4a4a4a',
    display: 'block',
    height: 500,
    '@media (max-width: 767px)': {
      height: 'initial',
      paddingBottom: '10px 0',
    },
  },
  container_TV: {
    backgroundColor: '#4a4a4a',
    display: 'block',
  },
  video: {
    width: '100%',
    maxHeight: 'calc(100% - 90px)',
  },
  controller: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 42px 0 24px',
    margin: '16px 0 12px 0',
    '@media (max-width: 767px)': {
      padding: '5px 10px',
      margin: 0,
      flexWrap: 'wrap',
    },
  },
  controlBtn: {
    color: '#fff',
    fontSize: 60,
    width: 200,
    backgroundColor: 'transparent',
    border: 0,
    outline: 'none',
    padding: 0,
    margin: '0 18px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.75,
    ':hover': {
      opacity: 0.96,
    },
    '@media (max-width: 767px)': {
      width: 90,
      fontSize: 30,
      margin: 0,
    },
  },
  progressBar: {
    display: 'flex',
    position: 'relative',
    width: 300,
    height: 32,
    padding: '15px 0',
    backgroundColor: '#fff',
    borderRadius: 1,
    backgroundClip: 'content-box',
    '@media (max-width: 767px)': {
      margin: '0px 10px',
      width: '100%',
      display: 'block',
    },
  },
  progressPan: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'block',
    borderRadius: 16,
    width: 32,
    height: 32,
    border: 0,
    outline: 'none',
    backgroundColor: '#FFF',
  },
  movieMode: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '24px 0',
  },
  movieModeToggle: {
    backgroundColor: '#fed312',
    width: 260,
    height: 42,
    lineHeight: '42px',
    borderRadius: 5,
    margin: '0 29px',
    border: 0,
    fontSize: 18,
    color: '#fff',
    fontWeight: 100,
    letterSpacing: 4,
    padding: '0 0 0 4px',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  movieModeToggle_TV: {
    backgroundColor: '#fed312',
    width: '40%',
    height: 80,
    lineHeight: '42px',
    borderRadius: 5,
    margin: '0 29px',
    border: 0,
    fontSize: 35,
    color: '#fff',
    fontWeight: 100,
    letterSpacing: 4,
    padding: '0 0 0 4px',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  reverseColor: {
    backgroundColor: '#f87c7f',
  },
  word: {
    fontSize: 15,
    display: 'block',
    color: 'black',
    padding: '15px 0',
  },
  word_TV: {
    fontSize: 30,
    display: 'block',
    color: 'black',
    textAlign: 'center',
  },
  linkIcon: {
    fontSize: 30,
    padding: '6px 0',
  },
  linkIcon_TV: {
    fontSize: 38,
    padding: '6px 0',
  },
  linkText: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  linkText_TV: {
    fontSize: 28,
    fontWeight: 'bold',
  },
  buttonText: {
    display: 'block',
    margin: '0px 10px',
    fontSize: 23,
    '@media (max-width: 767px)': {
      fontSize: 18,
    },
  },
  muteBtn: {
    '@media (max-width: 767px)': {
      width: 20,
    },
  },
};

class DetectionIntroPlayer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: true,
      volume: 50,
      muted: false,
      panStartX: null,
      barUnit: 3,
      lastTime: 0,
    };
  }

  componentDidMount() {
    const {
      video,
    } = this.refs;

    video.volume = 0.5;
    video.play();
    this.updateUnitSize();

    this.videoListener = () => this.videoEnd();
    video.addEventListener('ended', this.videoListener);
    window.addEventListener('resize', () => this.updateUnitSize(), false);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.stepKey !== this.props.stepKey) {
      this.refs.video.play();
      this.refs.video.addEventListener('ended', this.videoListener);
      this.setState({
        muted: false,
        volume: 50,
        panStartX: null,
        playing: true,
        barUnit: this.refs.bar.offsetWidth / 100,
      });
    }
  }

  updateUnitSize() {
    const {
      bar,
    } = this.refs;

    if (bar.offsetWidth) {
      this.setState({
        barUnit: bar.offsetWidth / 100,
      });
    }
  }

  mouseDown(panStartX) {
    const {
      muted,
    } = this.state;

    if (muted) {
      this.setState({
        panStartX,
        volume: 0,
        muted: false,
      });
    } else {
      this.setState({
        panStartX,
      });
    }
  }

  mouseMove(x) {
    const {
      volume,
      panStartX,
      barUnit,
    } = this.state;

    if (!panStartX) return;

    const {
      pan,
      bar,
      video,
    } = this.refs;

    const startX = panStartX - (barUnit * volume) - 16;
    const tempX = Math.min(Math.max(x - startX - 32, -16), 284);
    const tempVolume = (tempX + 16) / barUnit;

    let barStyle = `linear-gradient(to right, #fbbb0c 0, #fbbb0c ${tempVolume}%`;
    barStyle += `, transparent ${tempVolume}%, transparent 100%)`;

    bar.style.backgroundImage = barStyle;
    pan.style.left = `${tempX}px`;
    video.volume = tempVolume / 100;
  }

  mouseUp() {
    const {
      panStartX,
      barUnit,
    } = this.state;

    if (!panStartX) return;

    const {
      pan,
    } = this.refs;

    const nowX = parseInt(pan.style.left.replace(/px$/, ''), 10);
    const volume = (nowX + 16) / barUnit;

    this.setState({
      panStartX: null,
      volume,
      muted: !volume,
    });
  }

  togglePlayState() {
    const {
      video,
    } = this.refs;

    if (this.state.playing) {
      video.pause();
      window.removeEventListener('ended', this.videoListener);
    } else {
      video.addEventListener('ended', this.videoListener);
      video.play();
    }

    this.setState({
      playing: !this.state.playing,
    });
  }

  toggleMuteState() {
    const {
      video,
    } = this.refs;

    if (this.state.muted) {
      video.muted = false;
    } else {
      video.muted = true;
    }

    this.setState({
      muted: !this.state.muted,
    });
  }

  refreshPlayState() {
    const {
      video,
    } = this.refs;

    video.play();
    video.currentTime = 0;

    this.setState({
      playing: true,
    });
  }

  videoEnd() {
    window.removeEventListener('ended', this.videoListener);
    this.setState({
      playing: false,
    });
  }

  render() {
    const {
      questionList,
      stepKey,
      count,
      setStart,
    } = this.props;

    const {
      playing,
      volume,
      muted,
      barUnit,
    } = this.state;

    const activedSpec = questionList.find(s => s.key === stepKey);
    const seqNum = parseInt(stepKey, 10);
    if (!activedSpec) return <div style={styles.wrap}></div>;

    const actualVolume = muted ? 0 : volume;
    let barStyle = `linear-gradient(to right, #fbbb0c 0, #fbbb0c ${actualVolume}%`;
    barStyle += `, transparent ${actualVolume}%, transparent 100%)`;

    let wrap = styles.wrap;
    let container = styles.container;
    let movieModeToggle = styles.movieModeToggle;
    let word = styles.word;
    let linkIcon = styles.linkIcon;
    let linkText = styles.linkText;

    if (Helpers.Session.isViaTV()) {
      wrap = styles.wrap_TV;
      container = styles.container_TV;
      movieModeToggle = styles.movieModeToggle_TV;
      word = styles.word_TV;
      linkIcon = styles.linkIcon_TV;
      linkText = styles.linkText_TV;
    }

    return (
      <div style={wrap} onMouseUp={() => this.mouseUp()} onTouchEnd={() => this.mouseUp()}>
        <div style={container}>
          <video style={styles.video} ref="video" src={activedSpec.s3Path} autoPlay />
          {/* <video controls preload="auto" style={styles.video} ref="video" autoPlay>
            <source src={activedSpec.streaming} type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}
          <div style={styles.controller}>
            <button type="button" style={styles.controlBtn} onClick={() => this.togglePlayState()} key="play">
              <span className={`fa ${playing ? 'fa-pause' : 'fa-play'}`} />
              <span style={styles.buttonText}>{playing ? '暫停' : '播放'}</span>
            </button>
            <button
              type="button"
              style={styles.controlBtn}
              onClick={() => this.refreshPlayState()}
              key="refresh">
              <span className="fa fa-refresh" />
              <span style={styles.buttonText}>重播</span>
            </button>
            <button type="button" style={[styles.controlBtn, styles.muteBtn]} onClick={() => this.toggleMuteState()} key="mute">
              <span className={`fa ${muted ? 'fa-volume-off' : 'fa-volume-up'}`} />
            </button>
            <div
              ref="bar"
              onMouseMove={e => this.mouseMove(e.clientX)}
              onTouchMove={e => this.mouseMove(e.changedTouches[0].clientX)}
              style={[styles.progressBar, { backgroundImage: barStyle }]}>
              <button
                type="button"
                ref="pan"
                onMouseDown={e => this.mouseDown(e.clientX)}
                onTouchStart={e => this.mouseDown(e.changedTouches[0].clientX)}
                style={[styles.progressPan, { left: barUnit * actualVolume - 16 }]} />
            </div>
          </div>
        </div>
        <span style={word}>{activedSpec.word}</span>
        <div style={styles.movieMode}>
            {seqNum !== count ? (
              <Link
                to={`/detections/intro/step${seqNum + 1}`}
                style={movieModeToggle}>
                <span style={linkIcon} className="fa fa-circle-thin" />
                <span style={linkText}>是</span></Link>
            ) : (
              <button
                style={[movieModeToggle]}
                onClick={() => {
                  this.togglePlayState();
                  setStart();
                }}>
                <span style={linkIcon} className="fa fa-circle-thin" />
                <span style={linkText}>是</span>
              </button>
            )}
            {seqNum !== count ? (
              <Link
                to={`/detections/intro/step${seqNum + 1}`}
                style={[movieModeToggle, styles.reverseColor]}>
                <span style={linkIcon} className="fa fa-times" />
                <span style={linkText}>否</span></Link>
            ) : (
              <button
                style={[movieModeToggle, styles.reverseColor]}
                onClick={() => {
                  this.togglePlayState();
                  setStart();
                }}>
                <span style={linkIcon} className="fa fa-times" />
                <span style={linkText}>否</span>
              </button>
            )}
        </div>
      </div>
    );
  }
}

DetectionIntroPlayer.propTypes = {
  questionList: T.arrayOf(T.shape({
    key: T.number,
    name: T.string,
    video: T.string,
    word: T.string,
  })),
  stepKey: T.number,
  count: T.number,
  setStart: T.func,
};

export default connect(
  state => ({
    questionList: state.Detection.questionList,
  }),
  dispatch => bindActionCreators(DetectionActions, dispatch),
)(radium(DetectionIntroPlayer));



// WEBPACK FOOTER //
// ./containers/Detections/DetectionIntroPlayer.js